/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const MenuItem = React.forwardRef(({
  'aria-label': ariaLabel,
  description,
  children,
  value,
  selected,
  disabled,
  onClick
}, ref) => {

  const classes = classNames('sui-font-regular sui-text-base sui-leading-tight sui-px-3 sui-py-2',
    {
      'sui-flex sui-flex-col': !!description,
      'sui-text-primary focus:sui-text-inverse focus:sui-bg-input-focus focus:sui-outline focus:sui-outline-4 focus:sui-outline-focus': !disabled,
      'sui-text-inactive sui-pointer-events-none': disabled,
      'sui-bg-strong': selected,
      'hover:sui-bg-subtle': !selected && !disabled,
      'sui-cursor-pointer': !disabled
    });

  const onClickHandler = (event) => {
    if (onClick) {
      onClick(value, event);
    }
  };

  return (
    <li
      ref={ref}
      onClick={onClickHandler}
      className={classes}
      role="option"
      aria-selected={selected}
      aria-disabled={disabled}
      aria-label={ariaLabel}
    >
      <span>{children}</span>
      {
        description
        && <span className="sui-text-subtle">{description}</span>
      }
    </li>
  );
});

MenuItem.displayName = 'MenuItem';

MenuItem.propTypes = {
  /**
   * @ignore
   */
  'aria-label': PropTypes.string,
  /**
   * An additional description for the `MenuItem`
   */
  description: PropTypes.string,
  /**
   * The list item value
   */
  value: PropTypes.node,
  /**
   * If `true`, the list item is inactive and not selectable by user
   */
  disabled: PropTypes.bool,
  /**
   * Event fired when the user clicks `MenuItem`
   */
  onClick: PropTypes.func,
  /**
   * A string representing the `MenuItem` label
   */
  children: PropTypes.string.isRequired,
  /**
   * Indicate if the `MenuItem` is selected
   */
  selected: PropTypes.bool,
};

MenuItem.defaultProps = {
  description: null,
  onClick: null,
  disabled: undefined,
  selected: undefined,
  value: undefined,
};

export { MenuItem };
